import { AtomChannels, AtomTopics } from '@client/core/atoms/consts.js';
import { atom } from '@podium/store';
import type { MartailerPlacement } from '@schibsted-nmp/advertising-shared';

type RetailMediaAtom = {
  placements: Array<MartailerPlacement>;
  searchQuery?: string | undefined;
  categories?: string[] | undefined;
};

export const $retailMediaAtom = atom<$retailMediaAtom.Value>(
  AtomChannels.Podlet,
  AtomTopics.Martailer,
  {
    placements: [],
    searchQuery: undefined,
    categories: undefined
  }
);

export namespace $retailMediaAtom {
  export type Value = RetailMediaAtom;
}
